import { useCallback, useMemo, useState } from 'react';
import { Reaction, ReactionType } from '../model/post.types';

const MAX_INLINE_REACTIONS = 7;

export const useReactionsBar = (
  reactions: Reaction[],
  maxInline: number = MAX_INLINE_REACTIONS,
) => {
  const [expanded, setExpanded] = useState(false);

  const sorted = useMemo(
    () =>
      reactions
        .filter((reaction) => reaction.type !== ReactionType.Comment)
        .sort((a, b) => b.count - a.count),
    [reactions],
  );

  const visibleReactions = useMemo(
    () => (expanded ? sorted : sorted.slice(0, maxInline)),
    [sorted, expanded, maxInline],
  );

  const restCount = useMemo(
    () => Math.max(sorted.length - maxInline, 0),
    [sorted, maxInline],
  );

  const toggleExpanded = useCallback(() => setExpanded((value) => !value), []);

  return { visibleReactions, restCount, expanded, toggleExpanded };
};
